import { Grid, withStyles } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { Trans, useTranslations } from "../../../adapters/i18n";
import { montarTextoFiltro } from "../../../shared/utils";
import AlertModal from "../../shared/components/modalAlerta";
import {
  ALL_CATEGORIES_OPTION_VALUE,
  createCategoryOptions,
  filterDataForSelectedCategory,
  getCategoriesFromConciliationData,
  getDateValuesForFilter,
  PAGE_TYPE,
} from "../conciliacaoUtil";
import ConciliationDetailedTable from "./conciliationDetailedTable";
import ConciliationDetailsModal from "./conciliationDetailsModal";
import ConciliationHeader from "./conciliationHeader";
import ConciliationPrintTemplate from "./conciliationPrintTemplate";
import ConciliationSummaryTable from "./conciliationSummaryTable";
import history from "features/app/History";

export const ConciliationPage = ({
  categoryOperations,
  classes,
  conciliationStartDate,
  farm,
  farmConciliationData,
  getCategoryOperations,
  getConciliationData,
  selectedFarmId,
  setLoading,
  showConciliation,
}) => {
  const { t } = useTranslations();
  const componentRef = useRef();

  const { startFilterDate, endFilterDate } = getDateValuesForFilter(
    conciliationStartDate
  );

  const [formState, setFormState] = useState({
    categoryName: "",
    endDate: endFilterDate,
    isDetailsModalOpen: false,
    selectedCategory: ALL_CATEGORIES_OPTION_VALUE,
    startDate: startFilterDate,
  });

  const handleChangeFormField = (key, value) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    localStorage.setItem("firstRequest", "notMade");
  }, []);

  const handleGetConciliationData = async (startDate, endDate) => {
    montarTextoFiltro(startDate, endDate);

    setFormState((prev) => ({ ...prev, startDate, endDate }));

    await getConciliationData(
      selectedFarmId,
      startDate,
      endDate,
      conciliationStartDate
    );
  };

  useEffect(() => {
    handleGetConciliationData(startFilterDate, endFilterDate);
  }, []);

  const handleChangeStartDate = (date) => {
    handleChangeFormField("startDate", date);
  };

  const handleChangeEndDate = (date) => {
    handleChangeFormField("endDate", date);
  };

  const handleChangeSelectedCategory = (category) => {
    handleChangeFormField("selectedCategory", category);
  };

  const handleToggleDetailsModal = (categoryName) => {
    setFormState((prev) => ({
      ...prev,
      isDetailsModalOpen: !prev.isDetailsModalOpen,
      categoryName,
    }));
  };

  const handleGoToHomePage = () => {
    history.replace("/farol");
  };

  const handleGoToAnimalCategoryTab = () => {
    history.go(0);
  };

  const handleGetCategoryRecordDetails = async (categoryId) => {
    setLoading(true, true);

    await getCategoryOperations(
      selectedFarmId,
      categoryId,
      formState.startDate,
      formState.endDate
    );

    setLoading(false);
  };

  if (!showConciliation) {
    return (
      <AlertModal
        aoFechar={handleGoToHomePage}
        exibeBotaoFechar={true}
        descricao={
          <Trans
            i18nKey="conciliation:blocked-conciliation-modal.description"
            components={{ p: <p />, bold: <strong /> }}
          />
        }
        id="blocked-by-corral-operation-modal"
      />
    );
  }

  if (!conciliationStartDate) {
    return (
      <AlertModal
        aoFechar={handleGoToAnimalCategoryTab}
        exibeBotaoFechar={true}
        descricao={
          <p>
            <Trans
              i18nKey="conciliation:missing-start-date-modal.description"
              components={{ bold: <strong /> }}
            />
          </p>
        }
        id="missing-conciliation-start-date"
      />
    );
  }

  const animalCategories = getCategoriesFromConciliationData(
    farmConciliationData.Detalhes
  );
  const animalCategoriesOptions = createCategoryOptions(animalCategories, t);

  const conciliationDataForCategory = filterDataForSelectedCategory(
    farmConciliationData.Detalhes || [],
    formState.selectedCategory
  );

  return (
    <>
      <Paper square className={classes.root}>
        <Grid container className={classes.containerPage}>
          <Grid item className={classes.smallerArea}>
            <ConciliationHeader
              componentRef={componentRef}
              selectedCategory={formState.selectedCategory}
              categoriesList={animalCategoriesOptions}
              onSelectFormChange={handleChangeSelectedCategory}
              onButtonClick={handleGetConciliationData}
              startDate={formState.startDate}
              endDate={formState.endDate}
              onSelectStartDate={handleChangeStartDate}
              onSelectEndDate={handleChangeEndDate}
              conciliationStartDate={conciliationStartDate}
            />
          </Grid>
          <div className={classes.wrapperGeral}>
            <Grid item className={classes.smallerArea}>
              <ConciliationSummaryTable
                summary={farmConciliationData.Resumo}
                pageType={PAGE_TYPE.DEFAULT}
              />
            </Grid>

            <hr className={classes.horizontalRule} />

            <Grid item className={classes.smallerArea}>
              <ConciliationDetailedTable
                conciliationData={conciliationDataForCategory}
                onGetDetailedCollectData={handleGetCategoryRecordDetails}
                onShowDetailsModal={handleToggleDetailsModal}
                pageType={PAGE_TYPE.DEFAULT}
              />
            </Grid>
          </div>
        </Grid>
      </Paper>
      <ConciliationDetailsModal
        isOpen={formState.isDetailsModalOpen}
        onClose={handleToggleDetailsModal}
        startDate={formState.startDate}
        endDate={formState.endDate}
        categoryOperations={categoryOperations.items}
        categoryName={formState.categoryName}
      />

      <div style={{ display: "none" }}>
        <ConciliationPrintTemplate
          ref={(el) => (componentRef.current = el)}
          conciliationData={conciliationDataForCategory}
          onShowDetailsModal={handleToggleDetailsModal}
          onGetDetailedCollectData={handleGetCategoryRecordDetails}
          conciliationSummary={farmConciliationData.Resumo}
          categoryOptions={animalCategoriesOptions}
          selectedCategory={formState.selectedCategory}
          farm={farm}
          startDate={formState.startDate}
          endDate={formState.endDate}
        />
      </div>
    </>
  );
};

const styles = {
  typography: {
    fontFamily: "Roboto",
  },
  wrapperGeral: {
    width: "100%",
  },
  root: {
    width: "100%",
    height: "100%",
    zIndex: -1,
    padding: "46px",
    flexgrow: 1,
    minHeight: window.innerHeight,
  },
  containerPage: {
    flexgrow: 1,
    height: "100%",
    padding: "0",
    backgroundColor: "#fff",
    margin: "0 auto",
    width: "100%",
    position: "relative",
  },
  horizontalRule: {
    color: "#eeeeee",
    opacity: 0.3,
    height: "2px",
    width: "100%",
    marginTop: "32px",
    marginBottom: "28px",
  },
  smallerArea: {
    width: "100%",
    height: "auto",
    margin: "0em 0em",
    padding: "0.8em 0em",
  },
};

export default withStyles(styles)(ConciliationPage);
